import React, { useState } from 'react';
import Dollars from '../../../common/typeFormatting/Dollars';
import DateFmt from '../../../common/typeFormatting/Date';

const VoucherDetailRow = ({ voucher }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const currentYear = new Date().getFullYear();

  const isExpiringThisYear = (expirationDate) => {
    if (!expirationDate) return false;
    const expYear = new Date(expirationDate).getFullYear();
    return expYear === currentYear;
  };

  return (
    <>
      <tr 
        onClick={() => setIsExpanded(!isExpanded)} 
        style={{ 
          cursor: 'pointer',
          backgroundColor: isExpiringThisYear(voucher.expirationDate) ? '#fff3cd' : 'inherit'
        }}
      >
        <td style={{ width: '15%' }}><DateFmt>{voucher.issueDate}</DateFmt></td>
        <td style={{ width: '25%' }}>{voucher.voucherName}</td>
        <td style={{ width: '15%', textAlign: 'right' }}><Dollars>{voucher.initialAmount}</Dollars></td>
        <td style={{ width: '15%', textAlign: 'right', paddingRight: '2rem' }}><Dollars>{voucher.balance}</Dollars></td>
        <td style={{ width: '25%', paddingLeft: '4rem' }}>
          {voucher.expirationDate ? (
            <DateFmt>{voucher.expirationDate}</DateFmt>
          ) : (
            'Does not expire'
          )}
        </td>
        <td style={{ width: '5%', textAlign: 'center' }}>
          {voucher.transactions?.length > 0 ? (isExpanded ? '▲' : '▼') : ''}
        </td>
      </tr>
      {isExpanded && voucher.transactions?.map(transaction => (
        <tr key={transaction.tranId} style={{ backgroundColor: '#f8f9fa' }}>
          <td style={{ paddingLeft: '2rem', fontSize: 12 }}>
            <DateFmt>{transaction.tranDate}</DateFmt>
          </td>
          <td style={{ fontSize: 12 }}>{transaction.tranTypeId}{transaction.description != null ? " - " + transaction.description : ""}</td>
          <td></td>
          <td className="text-right" style={{ fontSize: 12, paddingRight: '2rem' }}>
            <Dollars>{transaction.amount}</Dollars>
          </td>
          <td colSpan={2}></td>
        </tr>
      ))}
    </>
  );
};

export default VoucherDetailRow;